import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseURL } from '../vay.config';

@Injectable({
  providedIn: 'root',
})
export class UploadService {
  constructor(private http: HttpClient) {}

  upload(form: any) {
    // return this.https.post(`${this.api}/uploader/images`, form);
    return this.http.post(`${BaseURL}/api/upload/images`, form, { reportProgress: true, observe: 'events' });
  }

  delete(id: any) {
    // return this.https.post(`${this.api}/uploader/images`, form);
    return this.http.delete(`${BaseURL}/api/upload/deleteS3File/${id}`);
  }
}
